export default __webpack_public_path__ + "5a16066ef7cdd56edf451e762060fad9.png";